<template>
  <v-form v-if="category" ref="form">
    <translation-input :label="$t('categories.name')" :obj.sync="category" field="nameTid" prefix="f.category.name"/>
    <translation-input :label="$t('categories.description')" :obj.sync="category" field="descriptionTid"
                       prefix="f.category.description"/>

    <v-autocomplete v-model="category.parentCategory" :items="richCategories" :label="$t('categories.parent_category')"
                    clearable item-text="nameText"
                    item-value="id"
                    return-object
    >

      <template v-slot:item="{item}">
        <div :style="`margin-left: ${(item.level * 40)}px`">
          <v-icon v-if="item.level > 0">mdi mdi-subdirectory-arrow-right</v-icon>
          {{ item.nameText }}
        </div>
      </template>

    </v-autocomplete>
    <v-select v-model="category.type" :items="$categoryTypes" :label="$tc('categories.type',2)" item-text="text"
              item-value="value" multiple></v-select>
    <v-text-field v-model="category.engineName" :label="$t('categories.engine_name')"
                  :rules="[$rules.required]"/>
  </v-form>
</template>

<script>

import TranslationInput from "@/components/TranslationInput";
import categoryApi from "@/api/category";

export default {
  name: "CategoryEditForm",
  components: {TranslationInput},
  data() {
    return {
      category: this.value /*{
        tid: null,
        ...Categorieservice.languages.reduce((acc, curr) => (acc[curr] = '', acc), {})
      }*/,
      dirty: false,
      categories: [],
    }
  },
  computed: {
    richCategories() {
      return this.getCategoriesRecursively(this.categories.filter(c => !c.parentCategory))
        .filter(c => c.level <= 2).flatMap(c => [c, ...c.children]);
    },
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  watch: {
    value(value) {
      this.category = value;
    },

    category(category) {
      this.$emit('input', category);
    },
    'category.parentCategory'() {
      this.category.parentCategoryId = this.category.parentCategory?.id;
    }
  },

  methods: {
    async getCategories() {
      this.categories = await categoryApi.getCategories();
    },

    getCategoriesRecursively(categories, level = 0) {
      return categories.filter(c => c.id !== this.category.id).map(c => {
        c.level = level;
        c.children = this.getCategoriesRecursively(this.categories.filter(cc => cc.parentCategory?.id === c.id), level + 1);
        return c;
      });
    },
  },
  mounted() {
    this.getCategories();
  },
}
</script>

<style scoped>

</style>
